'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { useSidebar } from '~/components/ContentLayoutClient';
import CourseNavigation from '~/components/CourseNavigation';
import FocusModeToggleButton from '~/components/FocusModeToggleButton';
import { CourseModule } from '~/payload-types';
export default function DesktopSidebar(t0) {
  const $ = _c(38);
  const {
    modules,
    courseHrefPrefix,
    currentModuleIds
  } = t0;
  const {
    isOpen,
    setIsOpen
  } = useSidebar();
  const [isInIframe, setIsInIframe] = useState(false);
  const [topOffset, setTopOffset] = useState(72);
  const toggleTop = topOffset + 56;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const detectedInIframe = document.documentElement.hasAttribute("data-in-iframe");
      setIsInIframe(detectedInIframe);
      if (!detectedInIframe) {
        return;
      }
      let raf = 0;
      const updateTopOffset = () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const headerBottom = document.querySelector("header")?.getBoundingClientRect().bottom ?? 0;
          setTopOffset(Math.max(0, headerBottom));
        });
      };
      updateTopOffset();
      window.addEventListener("scroll", updateTopOffset, {
        passive: true
      });
      window.addEventListener("resize", updateTopOffset, {
        passive: true
      });
      const observer = new MutationObserver(updateTopOffset);
      observer.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ["data-focus-mode", "data-focus-header"]
      });
      return () => {
        cancelAnimationFrame(raf);
        window.removeEventListener("scroll", updateTopOffset);
        window.removeEventListener("resize", updateTopOffset);
        observer.disconnect();
      };
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] !== isOpen || $[3] !== setIsOpen) {
    t3 = () => setIsOpen(!isOpen);
    $[2] = isOpen;
    $[3] = setIsOpen;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = `${toggleTop}px`;
  const t5 = isOpen ? "288px" : "0";
  let t6;
  if ($[5] !== t4 || $[6] !== t5) {
    t6 = {
      top: t4,
      right: t5
    };
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = isOpen ? "Close navigation" : "Open navigation";
  const t8 = `w-5 h-5 transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`;
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <polyline points="15 18 9 12 15 6" />;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] !== t8) {
    t10 = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={t8}>{t9}</svg>;
    $[9] = t8;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== t10 || $[12] !== t3 || $[13] !== t6 || $[14] !== t7) {
    t11 = <button onClick={t3} className="hidden lg:flex fixed z-50 bg-primary-100 text-white p-2 rounded-l-md hover:bg-primary-80 transition-all duration-300 shadow-lg [:has(.help-modal-open)_&]:hidden" style={t6} aria-label="Toggle navigation" title={t7}>{t10}</button>;
    $[11] = t10;
    $[12] = t3;
    $[13] = t6;
    $[14] = t7;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  const t12 = `hidden lg:block fixed right-0 w-72 bg-white shadow-lg z-40 transform transition-transform duration-300 ease-in-out overflow-y-auto border-l border-gray-200 md:top-16 md:bottom-9 lg:top-[72px] lg:bottom-10 in-iframe:bottom-auto in-iframe:overflow-visible ${isOpen ? "translate-x-0" : "translate-x-full"}`;
  let t13;
  if ($[16] !== isInIframe || $[17] !== topOffset) {
    t13 = isInIframe ? {
      top: `${topOffset}px`
    } : {};
    $[16] = isInIframe;
    $[17] = topOffset;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  const t14 = isOpen ? "0" : "-288px";
  let t15;
  if ($[19] !== t13 || $[20] !== t14) {
    t15 = {
      ...t13,
      right: t14
    };
    $[19] = t13;
    $[20] = t14;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <div className="flex items-center justify-between gap-3 mb-4"><h2 className="text-sm font-semibold uppercase tracking-wide text-gray-500">Navigation</h2><FocusModeToggleButton className="h-7 w-7" /></div>;
    $[22] = t16;
  } else {
    t16 = $[22];
  }
  let t17;
  if ($[23] !== courseHrefPrefix || $[24] !== currentModuleIds || $[25] !== modules) {
    t17 = <div>{t16}<CourseNavigation modules={modules} courseHrefPrefix={courseHrefPrefix} currentModuleIds={currentModuleIds} /></div>;
    $[23] = courseHrefPrefix;
    $[24] = currentModuleIds;
    $[25] = modules;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  let t18;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <div className="text-[10px] text-gray-400 uppercase tracking-wide mb-1.5">Legende</div>;
    $[27] = t18;
  } else {
    t18 = $[27];
  }
  let t19;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <div className="pt-3 border-t border-gray-200">{t18}<div className="flex items-center gap-1.5 text-[11px] text-gray-500"><span className="text-xs text-primary-100">▶</span><span className="italic">Aktuelle Woche im Kurs</span></div></div>;
    $[28] = t19;
  } else {
    t19 = $[28];
  }
  let t20;
  if ($[29] !== t17) {
    t20 = <div className="p-4 space-y-6">{t17}{t19}</div>;
    $[29] = t17;
    $[30] = t20;
  } else {
    t20 = $[30];
  }
  let t21;
  if ($[31] !== t12 || $[32] !== t15 || $[33] !== t20) {
    t21 = <nav className={t12} style={t15}>{t20}</nav>;
    $[31] = t12;
    $[32] = t15;
    $[33] = t20;
    $[34] = t21;
  } else {
    t21 = $[34];
  }
  let t22;
  if ($[35] !== t11 || $[36] !== t21) {
    t22 = <>{t11}{t21}</>;
    $[35] = t11;
    $[36] = t21;
    $[37] = t22;
  } else {
    t22 = $[37];
  }
  return t22;
}